<!-- <button class="btn btn-primary btn-raised btn-sm" (click)="openModal(content)">
<i class="fa fa-search"></i>
</button> -->
<span (click)="openModal(content)" class="cursor-pointer success" title="Visualizza opzioni">
  <i class="fa fa-search ml-1"></i>
</span>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{modalTitle}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container>
      <table class="table table-bordered table-striped">
        <tbody>
          @for (opt of options; track opt) {
            <tr>
              <td style="padding: 0px !important;" class="text-center">
                <button class="btn btn-link" (click)="modal.close(opt)" style="margin-bottom: 0px ! important">
                {{opt}}</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-sm btn-raised"
    (click)="modal.dismiss('Save click')">Chiudi</button>
  </div>
</ng-template>
